var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-wrapper" }, [
    _c("div", { staticClass: "row flex-wrapper" }, [
      _c("div", { staticClass: "row-item add-padding" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.onlineReward")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "light" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.yesterday")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.info.totalYesterdayFullReward || "--") + " dSLS")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "light" }, [
          _vm._v(
            _vm._s(
              _vm.$t("walletFullNode.quotaContent.all", {
                num: _vm.info.totalFullReward || "--"
              })
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row-item add-padding" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.voteReward")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "light" }, [
          _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.yesterday")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.info.totalYesterdayVoteReward || "--") + " dSLS")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "light" }, [
          _vm._v(
            _vm._s(
              _vm.$t("walletFullNode.quotaContent.all", {
                num: _vm.info.totalVoteReward || "--"
              })
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row add-padding" }, [
      _c("div", { staticClass: "title add-margin" }, [
        _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.nodeInfo")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-wrapper" }, [
        _c("div", { staticClass: "row-item" }, [
          _c("div", { staticClass: "light" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.onlineNodes")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.info.onlineNodeCount || "--"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row-item" }, [
          _c("div", { staticClass: "light" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.rewardNodes")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.info.pledgeNodeCount || "--"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row-item" }, [
          _c("div", { staticClass: "light" }, [
            _vm._v(_vm._s(_vm.$t("walletFullNode.quotaContent.stakeAmount")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v(
              _vm._s(_vm._f("formatNum")(_vm.info.pledgeAmount || 0)) + " dSLS"
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }